import React from "react";
import Link from "helpers/link";
import Money from "components/money";
import { useGlobalContext } from "context/global";

// Weight comes in GRAMS from Sanity
const PricePerKg = ({ price, weight }) => {
	const { translation } = useGlobalContext();
	if (!price || !weight || price <= 0) {
		return null;
	}

	const pricePerKg = (price * 1000) / parseFloat(weight);

	return (
		<span className="text-small my-2 text-secondary">
			<Money value={pricePerKg?.toFixed(2)} />{" "}
			/ Kg {translation.other?.incVat}, {translation.other?.including}{" "}
			<Link to={translation?.other?.shippingUrl} className="underline">
				{translation.other?.shipping}
			</Link>
		</span>
	);
};

export default PricePerKg;
